import React, { FC, useMemo, useState } from 'react'
import Modal from './Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isAdministrator } from '../../../utils/role'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface Props {
  type: string
  display: boolean,
  closeCallback: () => void
  extraOrderCallback: () => void
}

const PromotionModal: FC<Props> = (props) => {
  const {
    type,
    display,
    closeCallback,
    extraOrderCallback,
  } = props

  const {
    commonPart,
    login,
  } = useSelector((state: RootState) => (state))

  const closeModal = () => {
    closeCallback()
  }

  const [modalTitle, setModalTitle] = useState<string>("")

  const modalBody = useMemo(() => {
    if (!type) return <></>
    if (type === "task") {
      setModalTitle("工数管理")
      return (
        <>
          <p>
            プロジェクトごとにコスト・時間・業務割合を可視化します。
          </p>
          <p>
            各種集計データはリアルタイムに更新され、プロジェクト管理に役立ちます。
          </p>
          <img src="/static/images/promotion/image_task.png" alt="工数管理" style={{ width: "100%" }} />
        </>
      )
    }
    if (type === "analysis") {
      setModalTitle("組織分析")
      return (
        <>
          <p>
            取得したデータを各指標ごとに分析し、分析結果を提供します。
          </p>
          <p>
            使用アプリケーションやワークスタイル。印刷状況など様々なデータを提供します。
          </p>
          <img src="/static/images/promotion/image_analysis.png" alt="組織分析" style={{ width: "100%" }} />
        </>
      )
    }
    if (type === "ai_work") {
      setModalTitle("AI業務診断")
      return (
        <>
          <p>
            取得したデータを独自に解析し、月次・週次それぞれの解析結果をレポート形式で提供します。
          </p>
          <p>
            ユーザー個人のレポートはもちろん、チームデータを解析したレポートも提供します。
          </p>
          <img src="/static/images/promotion/image_ai_work.png" alt="AI業務診断" style={{ width: "100%" }} />
        </>
      )
    }
    if (type === "risk") {
      setModalTitle("リスクアセスメント")
      return (
        <>
          <p>
            ユーザー別、チーム別のデータを提供いたします。
          </p>
          <p>
            タイムライン機能やカスタムアラート機能により、状況の変化を察知することができます。
          </p>
          <img src="/static/images/promotion/image_risk.png" alt="リスクアセスメント" style={{ width: "100%" }} />
        </>
      )
    }
    if (type === "self") {
      setModalTitle("セルフマネジメント")
      return (
        <>
          <p>
            ユーザー自身のタイムラインデータを提供します。
          </p>
          <p>
            1日ごとの時系列データが表示され、振り返りなどに役立てることができます。
          </p>
          <img src="/static/images/promotion/image_self.png" alt="セルフマネジメント" style={{ width: "100%" }} />
        </>
      )
    }
    return <></>
  }, [type])

  return (
    <Modal
      modalSize="large"
      show={display}
      closeCallback={closeModal}
      closeable
      wrapperClass="promotionModal"
    >
      <>
        <div className="header_text">
          現在の契約ではご利用になれない機能です
        </div>
        <div className="title">
          {modalTitle}
        </div>
        <div>
          {modalBody}
        </div>
        <div className="footer_text">
          {
            (isAdministrator(commonPart.role) && login.feature_config?.change_contract) ? (
              <button
                type="button"
                className="button change_contract"
                onClick={() => extraOrderCallback()}
              >
                <FontAwesomeIcon icon={['far', 'lightbulb']} />
                オプション機能の開放
              </button>
            ) : (
              <>
                機能解放に関するご相談は管理者またはカスタマーサクセスまでご連絡ください
              </>
            )
          }
        </div>
      </>
    </Modal>
  )
}

export default PromotionModal
